module.exports = __webpack_public_path__ + "img/watch-later-black-24-dp.a1651b53.svg";